import React, { useState } from "react";
import {
    Avatar,
    Box,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Typography,
    Button,
} from "@mui/material";
import { CloseIcon } from "../../../helper/Icons";
import CommonButton from "../../../components/common/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const UploadStock = ({ handleClose, handelClick, modalOpen, stockFile, setStockFile, }) => {
    const [fileName, setFileName] = useState(null);
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name);
            setStockFile(file);
        }
    };

    const handleCancel = () => {
        setStockFile(null);
        setFileName(null);
        handleClose();
    }
    return (
        <>
            <DialogTitle sx={{ m: 0, p: 2 }} id="Common_modal">
                Bulk Upload Stock
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => handleCancel()}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent sx={{ minWidth: { xs: "100%", sm: "500px" } }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography
                            variant="body2"
                            sx={{ color: "#6b7280", marginBottom: "1.5rem" }}
                        >
                            Drag and drop a file here, or click the button below to select a file.
                        </Typography>
                        <label htmlFor="raised-button-file">
                            <Box
                                sx={{
                                    border: "1px dashed #e5e7eb",
                                    padding: "1rem",
                                    borderRadius: "8px",
                                    cursor: "pointer",
                                    textAlign: "center",
                                    background: "#ffffff",
                                }}
                            >
                                <input
                                    type="file"
                                    id="raised-button-file"
                                    onChange={handleFileUpload}
                                    style={{ display: "none" }}
                                    accept=".xls, .xlsx"
                                />
                                <CloudUploadIcon
                                    sx={{ fontSize: "3rem", color: "#4f46e5", marginBottom: "0.5rem", fill: "rgb(0 61 83)" }}
                                />
                                <Typography variant="body2" sx={{ color: "#6b7280" }}>
                                    {fileName ? fileName : "Click to upload or drag file here"}
                                </Typography>
                            </Box>
                        </label>
                        {fileName && (
                            <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
                                <CheckCircleIcon
                                    sx={{ color: "#22c55e", marginRight: "0.5rem", fill: "#009d3a" }}
                                />
                                <Typography variant="body2" sx={{ color: "#003d53fc" }}>
                                    {fileName} selected successfully
                                </Typography>
                            </Box>
                        )}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center", padding: "1rem" }}>
                <CommonButton
                    buttonName={"Upload"}
                    onClick={handelClick}
                />
                <CommonButton
                    buttonName={"Cancel"}
                    onClick={() => handleCancel()}
                    color="white"
                    sx={{ ml: 2 }}
                />
            </DialogActions>
        </>
    );
}

export default UploadStock;